import { IconName } from './icon-name';

//
// This file was generated by a tool 🛠️
// > npm run generate-mop-icons
//
// ☠️ Do not edit this file manually! ☠️
//

export const outlinedIconNames = new Set<IconName>([
  'accessibility-circle',
  'accessibility',
  'add-bold',
  'add-circle',
  'add-heavy',
  'add',
  'address',
  'advanced-instructions',
  'alarm-add',
  'alarm-off',
  'alarm-on',
  'alert-outlined',
  'alert',
  'align-bottom',
  'align-center-horiz',
  'align-center-vert',
  'align-left',
  'align-right',
  'align-top',
  'angle-90',
  'antenna',
  'apps',
  'arc',
  'arrow-back',
  'arrow-down-circle',
  'arrow-down',
  'arrow-expand-diagonal-left',
  'arrow-expand-diagonal-right',
  'arrow-left-circle',
  'arrow-left',
  'arrow-next',
  'arrow-right-circle',
  'arrow-right',
  'arrow-up-circle',
  'arrow-up',
  'artificial-intelligence',
  'backup-restore-cloud',
  'backup-restore-file',
  'bar-graph-line',
  'bar-graph-square',
  'bar-graph',
  'barcode',
  'battery-0-horizontal',
  'battery-0-vertical',
  'battery-25-horizontal',
  'battery-25-vertical',
  'battery-50-horizontal',
  'battery-50-vertical',
  'battery-75-horizontal',
  'battery-75-vertical',
  'battery-charging-horizontal',
  'battery-charging-vertical',
  'battery-full-horizontal',
  'battery-full-vertical',
  'between',
  'bolt',
  'bookings-open',
  'bookings',
  'box-select',
  'briefcase',
  'brightness',
  'brush',
  'bug-report',
  'bug',
  'building-corporate',
  'buildings',
  'calculate',
  'calculator-symbols',
  'calculator',
  'calendar-add',
  'calendar-and-key',
  'calendar-blank',
  'calendar-booking',
  'calendar-cancel',
  'calendar-check',
  'calendar-clock',
  'calendar-event',
  'calendar-loading-unloading-date',
  'calendar-loading-unloading',
  'calendar-plus',
  'calendar-rebook',
  'calendar-reserve',
  'calendar-show',
  'calendar-time-slot',
  'calendar-week',
  'calendar',
  'camera-disabled',
  'camera-photo-add',
  'camera',
  'cancel-circle',
  'cancel-square-outlined',
  'cancel-square',
  'caret-down-bold',
  'caret-down',
  'caret-left-bold',
  'caret-left',
  'caret-right-bold',
  'caret-right',
  'caret-up-bold',
  'caret-up',
  'cell-merge',
  'cell-properties',
  'cell-split',
  'certificate',
  'chat',
  'check-bold',
  'check-circle-outlined',
  'check-circle',
  'check-heavy',
  'check',
  'chevron-double-down',
  'chevron-double-left',
  'chevron-double-right',
  'chevron-double-up',
  'chevron-left-bold',
  'chevron-left',
  'chevron-right-bold',
  'chevron-right',
  'circle-notch',
  'circle-outline',
  'clipboard-actions',
  'clipboard-check',
  'clipboard-empty',
  'clipboard-planning',
  'clipboard',
  'clock-add',
  'clock-checkmark',
  'clock-delay-warning',
  'clock-delayed',
  'clock-locked',
  'clock-question-mark',
  'clock',
  'close-bold',
  'close-heavy',
  'close',
  'cloud-connected',
  'cloud-disconnected',
  'cloud-download',
  'cloud-upload',
  'cloud',
  'code',
  'coffee-cup',
  'collapse-bold',
  'collapse',
  'color-picker',
  'column-copy',
  'column-cut',
  'column-delete',
  'column-insert-after',
  'column-insert-before',
  'column-paste-after',
  'column-paste-before',
  'column-properties',
  'columns',
  'combine',
  'comment-add',
  'comment-empty',
  'comment-message-disabled',
  'comment-message',
  'comment',
  'compare-arrows',
  'compass',
  'component',
  'contacts',
  'contrast',
  'copy-content',
  'costs',
  'credit-card',
  'crop',
  'cube',
  'curly-brackets',
  'cursor-add',
  'cursor-remove',
  'cursor',
  'dashboard',
  'data-missing',
  'data-transfer-off',
  'day-mostly-cloudy',
  'day-partly-cloudy',
  'delete',
  'delivery-truck-allocate',
  'delivery-truck-motion',
  'delivery-truck',
  'document',
  'download-line',
  'download-xls',
  'download',
  'drag-corner',
  'drag-horizontal',
  'drag-indicator',
  'drag-vertical',
  'drivers',
  'drizzle',
  'drone',
  'earnings-statement',
  'edit-combination',
  'email-add',
  'email',
  'envelope',
  'eraser',
  'exclamation-mark',
  'expand-bold',
  'expand-less-bold',
  'expand-less-circle',
  'expand-less',
  'expand-more-bold',
  'expand-more-circle',
  'expand-more',
  'expand',
  'export',
  'factory',
  'fast-forward',
  'fast-rewind',
  'file-bar-graph',
  'file-check-in',
  'file-check-out',
  'file-cloud',
  'file-copy',
  'file-edit',
  'file-merge',
  'file-missing',
  'file-new',
  'file-secure',
  'file-table',
  'file-type-bmpf',
  'file-type-csv',
  'file-type-cur',
  'file-type-doc',
  'file-type-ico',
  'file-type-key',
  'file-type-log',
  'file-type-numbers',
  'file-type-pdf',
  'file-type-pem',
  'file-type-rfi',
  'file-type-rfq',
  'file-type-rtf',
  'file-type-text',
  'file-type-tif',
  'file-type-tmp',
  'file-type-xls',
  'file',
  'filter-list',
  'filter-off',
  'filter',
  'first-page',
  'flag-finish',
  'flag',
  'floorplan',
  'flowchart',
  'fog',
  'folder-closed',
  'folder-locked',
  'folder-new',
  'folder-open',
  'folder-personal',
  'folder-project',
  'folder-public',
  'folder-share',
  'folder-unlocked',
  'footprints',
  'forestry',
  'forklift',
  'frame',
  'freight-market',
  'freight-matching',
  'freight-trolley',
  'full-screen',
  'function',
  'gantt-chart',
  'gavel',
  'gears',
  'greater-than-equal-to',
  'group-items',
  'hail-heavy',
  'hail-light',
  'hail',
  'hammer',
  'hand',
  'hard-hat',
  'headset',
  'heart',
  'helicopter',
  'help-outlined',
  'help',
  'history',
  'home',
  'hourglass',
  'ice',
  'icons-shapes',
  'image-add',
  'image-disabled',
  'image-scene',
  'image',
  'in-cab-device',
  'in-field-device',
  'info-outlined',
  'info-token',
  'info',
  'inspect',
  'invoice-euro',
  'invoice-pound',
  'invoice-yen',
  'invoice',
  'item-begins-with',
  'item-contains',
  'item-does-not-contain',
  'item-does-not-equal',
  'item-ends-with',
  'item-equals',
  'key',
  'keyboard-keys',
  'keyboard',
  'labs',
  'language',
  'last-page',
  'launch-bold',
  'launch',
  'layer',
  'learn',
  'less-than-equal-to',
  'lightbulb-off',
  'lightbulb-on',
  'lightning',
  'line-diagonal',
  'line-graph',
  'link-broken',
  'link-off',
  'link',
  'list-bulleted',
  'list-numbered',
  'list-shapes',
  'location-add-multiple',
  'location-add',
  'location-arrow',
  'location-disabled',
  'location-point',
  'location',
  'lock-open',
  'lock',
  'magic-wand',
  'manage-accounts',
  'manage-people',
  'map-2d',
  'map-marker-circle',
  'map-marker-multiple',
  'map-marker',
  'map-markers',
  'map-poi',
  'map',
  'master-data',
  'megaphone',
  'menu-circle',
  'menu',
  'mic',
  'mix',
  'mobile-app-version',
  'monetarization',
  'moon',
  'more-circle',
  'more-horizontal',
  'more-vertical',
  'mouse',
  'move-last-down',
  'move-last-left',
  'move-last-right',
  'move-last-up',
  'move',
  'night-mostly-cloudy',
  'night-partly-cloudy',
  'no-package',
  'no-truck',
  'not-synced-bold',
  'notifications-off',
  'notifications',
  'object-mirror',
  'object-outline',
  'object-rotate',
  'offers',
  'overcast',
  'package-delivered',
  'package-delivery',
  'package-missing',
  'package-pickup',
  'package-sent',
  'package',
  'pager',
  'paint-bucket',
  'palette',
  'pan',
  'paper-plane',
  'paperclip',
  'password',
  'pause-circle',
  'payment-instant',
  'pen',
  'pencil',
  'people-add',
  'people-couple',
  'people-group',
  'person-account',
  'person-add',
  'person-clock',
  'person-edit',
  'person-remove',
  'person',
  'phone-call',
  'phone-hang-up',
  'phone-mobile',
  'phone',
  'pin-add',
  'pin-straight-cancel',
  'pin-straight',
  'pin',
  'play-circle',
  'point-marker-tool',
  'polygon-area-tool',
  'polygon-concave',
  'polygon-cone',
  'polygon-drag-rectangle',
  'polygon-line-tool',
  'polygon-merge',
  'polygon-select',
  'polygon',
  'printer',
  'pulse',
  'qr-code',
  'question',
  'quick-login',
  'rain-heavy',
  'rain-icy',
  'rain',
  'raindrop',
  'redo-bold',
  'redo',
  'refresh-bold',
  'refresh',
  'remove-bold',
  'remove-circle',
  'remove-heavy',
  'remove',
  'reply',
  'rewind',
  'row-add',
  'row-copy',
  'row-cut',
  'row-delete',
  'row-highlighted',
  'row-insert-after',
  'row-insert-before',
  'row-paste-after',
  'row-paste-before',
  'row-properties',
  'row-remove',
  'rows-show-less',
  'rows-show-more',
  'rss-feed',
  'ruler',
  'satellite',
  'save-as',
  'save-disk',
  'scan-barcode',
  'schema',
  'scissors',
  'screen',
  'screenshot',
  'search',
  'server-round',
  'server',
  'settings',
  'share',
  'shield',
  'shopping-cart-minus',
  'shopping-cart-plus',
  'shopping-cart',
  'shortcut',
  'shovel',
  'show-less-caret',
  'show-more-caret',
  'sign-in',
  'sign-out',
  'signal',
  'smiley-dissatisfied-outlined',
  'smiley-dissatisfied',
  'smiley-neutral-outlined',
  'smiley-neutral',
  'smiley-satisfied-outlined',
  'smiley-satisfied',
  'smiley-somewhat-dissatisfied-outlined',
  'smiley-somewhat-dissatisfied',
  'smiley-somewhat-satisfied-outlined',
  'smiley-somewhat-satisfied',
  'snow-heavy',
  'snow-light',
  'snow-particle',
  'snowflake',
  'snowflakes',
  'sort-alpha-down',
  'sort-alpha-up',
  'sort-arrow-down',
  'sort-arrow-up',
  'sort-down',
  'sort-up',
  'sort',
  'star-half',
  'star-locked',
  'star-northern',
  'star-outlined',
  'star',
  'stars',
  'stop-circle',
  'street-measurement',
  'submit-expense',
  'sun',
  'swap',
  'switch-account',
  'switch-left',
  'switch-right',
  'sync-bold',
  'sync-off',
  'sync',
  'table',
  'tablet',
  'tag-disabled',
  'tag',
  'template',
  'text-align-left',
  'text-align-right',
  'text-bold',
  'text-centered',
  'text-grow',
  'text-input-long',
  'text-input-short',
  'text-input',
  'text-italic',
  'text-marker',
  'text-shrink',
  'text-strikethrough',
  'text-truncated',
  'text-underlined',
  'thermometer-cold',
  'thermometer-hot',
  'thumbs-down',
  'thumbs-up',
  'thunderstorm-heavy',
  'thunderstorm-light',
  'ticket-plane',
  'ticket',
  'time-off-work',
  'time-slot-not-reserved',
  'time-slot-reserved',
  'timer-countdown',
  'timer',
  'timesheet-approve',
  'timesheet',
  'toggle-center',
  'toggle-left-panel',
  'toggle-off',
  'toggle-on',
  'toggle-right-panel',
  'traffic-cone',
  'tree-structure',
  'triangle-down',
  'triangle-left',
  'triangle-right',
  'triangle-up',
  'trimble-logo',
  'truck-add',
  'truck-warning-delay',
  'tune-circle',
  'tune',
  'uncombine',
  'undo-bold',
  'undo',
  'unfold-less',
  'unfold-more',
  'unit-selector',
  'unsorted-arrows',
  'update',
  'upload-xls',
  'upload',
  'user-account',
  'user-active',
  'user-guide',
  'user-inactive',
  'user-passkey',
  'user-permissions',
  'video-add',
  'video-disabled',
  'video',
  'view-grid',
  'view-list',
  'visibility-off',
  'visibility-on',
  'volume-down',
  'volume-mute',
  'volume-up',
  'vr-xr',
  'warehouse',
  'warning-outlined',
  'warning',
  'web',
  'wheelbarrow',
  'widgets',
  'wifi-no-internet',
  'wifi-off',
  'wifi',
  'wind',
  'window-dock-undock',
  'window-fit',
  'window-resize',
  'window-side-panel',
  'window-template',
  'window-views',
  'window-wireframe',
  'window',
  'wintery-mix',
  'wrench',
  'zoom-box',
  'zoom-in',
  'zoom-out',
]);
